<template>
  <a
    class="font-semibold"
    :class="{
      'cursor-pointer text-primary': !disabled,
      'pointer-events-none cursor-not-allowed text-gray-500': disabled,
      underline: underlined,
    }"
    :target="openInNewTab ? '_blank' : '_self'"
    rel="noreferrer noopener"
  >
    <slot />
  </a>
</template>

<script setup lang="ts">
defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
  underlined: {
    type: Boolean,
    default: true,
  },
  openInNewTab: {
    type: Boolean,
    default: false,
  },
});
</script>
